<template>
    <service-card
        :service-tips="serviceTips"
        :service="service"
        icon="mdi-lightning-bolt-outline"
        :is-first="isFirst"
        :extra-service-name="info.serviceName"
        :order="order"
        :variants-available="variantsAvailable"
        @modify-service="$emit('modify-service', $event)"
        @show-info="showInfo"
        @minimized-change="minimizedChange"
    >
        <template v-slot:checkbox>
            <slot name="checkbox" />
        </template>
        <template v-slot:icons>
            <slot name="icons" />
        </template>
        <template v-slot:orderInfo>
            <order-info-base
                :service-check-in="$filters.dateTimeFormat(service.startDateTime)"
                :service-check-out="
                    service.startDateTime !== service.endDateTime ? $filters.dateTimeFormat(service.endDateTime) : null
                "
                :service="service"
                :service-image="mainImage"
                :tariff-name="service.serviceDetails[0].tariffName"
                :is-package="isPackage"
                :service-label="info.serviceName"
                :order="order"
                :order-end-date="orderEndDate"
                @cancel-service="$emit('cancel-service', $event)"
                @modify-service="$emit('modify-service', $event)"
            >
                <template v-if="variant" v-slot:additionalInfo>
                    <small class="d-block hotel-address mt-2">
                        {{ variant }}
                    </small>
                </template>
                <div v-if="quantity" class="order-info-base-info">
                    <span class="order-info-base-info__icon">
                        <v-icon start size="x-small">mdi-alpha-q-circle-outline</v-icon>
                        <span class="text-body-2">{{ $t('quantity') }}</span>
                    </span>
                    <span class="order-info-base-info__text">{{ quantity }}</span>
                </div>
            </order-info-base>
        </template>
        <template v-slot:serviceInfo>
            <service-info-dialog
                v-model="modal"
                :image="mainImage"
                :service="service"
                :info="info"
                :is-info-loading="isInfoLoading"
            >
                <template v-slot:serviceInfo>
                    <div v-if="info.shortDescription" class="mt-2">
                        <span class="d-block text-subtitle-1 font-weight-medium">
                            {{ $t('description_type.short') }}
                        </span>
                        <span v-html="info.shortDescription" />
                    </div>
                    <div v-if="info.fullDescription" class="mt-2">
                        <span class="d-block text-subtitle-1 font-weight-medium">
                            {{ $t('description_type.general') }}
                        </span>
                        <span v-html="info.fullDescription" />
                    </div>
                    <div v-if="info.pleaseNote" class="mt-2">
                        <span class="d-block text-subtitle-1 font-weight-medium">
                            {{ $t('important_information') }}
                        </span>
                        <span v-html="info.pleaseNote" />
                    </div>
                    <div
                        v-if="service.serviceDetails[0].description"
                        class="make-new-line"
                        v-html="service.serviceDetails[0].description"
                    />
                    <div v-if="info.productDescription" v-html="info.productDescription" />
                </template>
            </service-info-dialog>
        </template>
    </service-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import ServiceCard from '~src/components/account/orderServices/serviceCard.src'
    import ServiceInfoDialog from '~/components/account/orderServices/ServiceInfoDialog.vue'
    import {ServiceBase} from '@/components/account/orderServices/ServiceBase.vue'
    import OrderInfoBase from '~src/components/account/orderServices/orderInfoBase.src'

    @Component({
        components: {
            ServiceInfoDialog,
            OrderInfoBase,
            ServiceCard,
        },
    })
    export class ExtraserviceService extends ServiceBase {
        @Prop({required: true}) service
        @Prop({default: false}) isPackage
        @Prop() isFirst

        info = {}

        modal = false

        showInfo() {
            if (!this.infoLoadingFinished) {
                this.loadProductInfo()
            }

            this.modal = true
        }

        async loadProductInfo() {
            this.isInfoLoading = true
            const processId = this.service.processId.replace(/^.{6}/, '')

            try {
                this.info = await this.$api.ownExtraServiceInfo.get({processId})
                // eslint-disable-next-line no-empty
            } catch (e) {}

            this.isInfoLoading = false
            this.infoLoadingFinished = true
        }

        get mainImage() {
            if (this.info.images && this.info.images.length) {
                let image = this.info.images.find(el => el.mainImage)
                if (!image) {
                    image = this.info.images[0]
                }
                return image.url
            }
            return null
        }

        get quantity() {
            return this.service.serviceDetails.length ? this.service.serviceDetails[0].quantity : ''
        }

        get variant() {
            return this.service.serviceDetails.length ? this.service.serviceDetails[0].productVariantName : ''
        }
    }

    export default ExtraserviceService
</script>

<style lang="scss" scoped>
    :deep(.v-dialog) {
        background: #fff;
        padding: 20px;
    }

    .modal-close-btn-block {
        position: relative;
        top: 12px;
        right: 12px;
    }

    .make-new-line {
        white-space: pre-line;
    }
</style>
